import cookie from "js-cookie";

// Test Identity is a persistent value stored in the user's cookies
// It enables us to serve a feature flag experience for testing

const TEST_IDENTITY_ID = "test_identity";

export const getTestIdentity = (): string => {
  let testIdentity = cookie.get(TEST_IDENTITY_ID);

  if (!testIdentity) {
    testIdentity = "test";
    cookie.set(TEST_IDENTITY_ID, testIdentity);
  }

  return testIdentity;
};
